const faqAPI = [
  {
    id: "collapseOne",
    question: "How do I book an appointment with a doctor?",
    answer: `To book an appointment, simply visit our website, browse available doctors, select the one you need, and click on the "Book Appointment" button. Follow the prompts to complete the process.`,
  },

  {
    id: "collapseTwo",
    question: "Can I see a doctor's availability before booking?",
    answer: `Yes, you can view a doctor's available time slots, allowing you to choose a convenient appointment time that fits your schedule.`,
  },

  {
    id: "collapseThree",
    question: "Is my payment information secure?",
    answer: `Absolutely. We prioritize your security. We use industry-standard encryption and secure payment gateways to protect your financial information.`,
  },
  {
    id: "collapseFour",
    question: "Do I need to create an account to book an appointment?",
    answer: `It's not mandatory, you have to choose the doctor then fill the appointment form and book your appointment then you will get the message if your appointment has booked`,
  },
  {
    id: "collapseFive",
    question: "Can I review a doctor's qualifications and patient reviews?",
    answer: `Yes, you can view a doctor's profile, including their qualifications, specialties, and patient reviews, to make an informed choice.`,
  },
  {
    id: "collapseSix",
    question: "What if I have a medical emergency?",
    answer: `In the case of a medical emergency, please call 112 or visit your nearest emergency room. Our platform is for non-emergency appointments.`,
  },
  {
    id: "collapseSeven",
    question: "Do you offer telemedicine appointments?",
    answer: `Yes, some doctors on our platform offer telemedicine appointments. You can specify your preference when booking.`,
  },
  {
    id: "collapseEight",
    question:
      "What happens if the doctor I've booked is unavailable on the day of my appointment?",
    answer: `While rare, if a doctor becomes unavailable, we will work to reschedule your appointment with another qualified healthcare provider or offer a refund if rescheduling isn't possible.`,
  },
];

export default faqAPI;
